import React from "react";
import { FaInfoCircle } from "react-icons/fa";

import FieldAppCalibrationCheckSummary from "./FieldAppCalibrationCheckSummary";
import { CALIBRATION_PLATFORM_DEMO_PAYLOAD } from "./calibrationCheckAverages";
import { CalibrationCheckHelpContent } from "./calibrationCheckHelpContent";

import "./FieldAppCalibrationPanel.css";

function FieldAppCalibrationPanel({ t, children }) {
  return (
    <div className="field-app-calibration">
      <div className="field-app-calibration-help" role="note">
        <FaInfoCircle className="field-app-calibration-help-icon" aria-hidden />
        <div className="field-app-calibration-help-body">
          <strong>{t("Para que serve esta ferramenta?")}</strong>
          <CalibrationCheckHelpContent />
        </div>
      </div>
      <FieldAppCalibrationCheckSummary
        payload={CALIBRATION_PLATFORM_DEMO_PAYLOAD}
        t={t}
        demo
        title={t("Exemplo: como o check sobe do app")}
        note={t(
          "Quando o operador salva a abastecida, o app envia esta abastecida, a média das últimas 3 e a média total — vinculadas à ordem de serviço. Ao clicar num registro real, os números vêm do campo."
        )}
      />
      {children}
    </div>
  );
}

export default FieldAppCalibrationPanel;
